import { useEffect, useState } from 'react'
import { RecognitionState } from '../../models/enums'

const useActiveRecognitionState = (instanceId?: string): RecognitionState => {
  const [current, setCurrent] = useState<number>(RecognitionState.Closed)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_activeRecognitionState', ((e: CustomEvent) => handleChange(e)) as EventListener)
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_activeRecognitionState'))

    return () => {
      document.removeEventListener('retorik_activeRecognitionState', ((e: CustomEvent) => handleChange(e)) as EventListener)
    }
  }, [])

  return current
}

export default useActiveRecognitionState
